<template>
  <div class="cont cur">
    <div class="list" v-for="(release, index) in releases" :key="index">
      <div class="title clearfix" :class="{ 'updata-close': !release.open }">
        <h3>{{ release.version_no }}</h3>
        <a class="pull-right" @click="toggle(release)">
          <i class="ti-angle-down"></i>
        </a>
        <span>更新时间：{{ release.released_at }}</span>
      </div>
      <div class="info collapse" :class="{ in: release.open }">
        <ol>
          <li v-html="release.content"></li>
        </ol>
      </div>
    </div>
    <div class="list" v-if="!releases.length">
      <div class="title clearfix">
        <h3>暂无版本信息</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { clientReleases } from "@/api/common/index";
export default {
  name: "WindowsSync",
  data() {
    return {
      releases: [],
      query: {
        offset: 0,
        limit: 20,
        terminal_type: "6",
      },
    };
  },
  methods: {
    toggle(release) {
      release.open = !release.open;
    },
    clientReleases() {
      clientReleases(this.query)
        .then((res) => {
          if (res.status_code === 200) {
            this.releases = res.entity.map((item) => {
              item.open = true;
              return item;
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    this.clientReleases();
  },
};
</script>

<style scoped>
</style>